import styled from 'styled-components'
import { colors, spacing } from '@chegg-ui/theme'
import { Popover } from '@chegg-ui/popover'

export const PopoverWrapper = styled(Popover)``

export const PopoverContainer = styled.ul`
  text-decoration: none;
  margin: 0;
  padding: 0;
  list-style-type: none;

  padding: ${spacing.px4};
`

export const PopoverContainerListItem = styled.li`
  margin: 0;
  padding: 0;
`

export const PopoverItemButton = styled.button`
  outline: none;
  margin: 0;
  padding: 0;
  background: none;
  border: none;

  display: flex;
  align-items: center;
  padding: ${spacing.px4};
  border-radius: ${spacing.px8};

  &:hover,
  &:active {
    background-color: ${colors.grey100};
  }
`
